type VesselDetailsValidation = {
  year: number;
  make: string;
  model: string;
  max_length: number;
  capacity: number;
};

export const validateVesselYear = (year: number): boolean => (
  year > 0 // TODO: what is the real minimum?
);

export const validateVesselMake = (make: string): boolean => (
  !!(make?.trim()?.length > 0)
);

export const validateVesselModel = (model: string): boolean => (
  !!(model?.trim()?.length > 0)
);

export const validateVesselMaxLength = (maxLength: number): boolean => (
  maxLength > 0
);

export const validateCapacity = (capacity: number): boolean => (
  capacity > 0 && capacity <= 1000
);

export const validateVesselDetails = ({
  year, make, model, max_length, capacity,
}: VesselDetailsValidation): boolean => (
  validateVesselYear(year)
  && validateVesselMake(make)
  && validateVesselModel(model)
  && validateVesselMaxLength(max_length)
  && validateCapacity(capacity)
);
